import React, { useEffect, useState } from "react";
import SectionTitle from "../components/SectionTitle";
import NewsItem from "./components/NewsItem";
import { findObjectUseCase } from "../../../usecases/object";

export default function News() {
  const [news, setNews] = useState();

  useEffect(() => {
    const fetchNews = async () => {
      await findObjectUseCase()
        .execute("news")
        .then((res) => {
          setNews(res);
        });
    };

    fetchNews();
  }, []);

  return (
    <div className="d-flex w-100 align-items-center flex-column pt-4 pb-5 ps-3 pe-3 gap-3">
      <div className="text-center pb-1">
        <SectionTitle title="News" />
      </div>
      <div className="d-flex p-lg-4 flex-wrap gap-4 w-100">
        {news?.map((news) => {
          return <NewsItem key={news} news={news} />;
        })}
      </div>
    </div>
  );
}
